import { message } from 'antd';

const config = {
  style: {
    marginTop: '10vh',
  },
  duration: 2,
};

export default {
  success: (content: any) => message.success({ content, ...config }),
  error: (content: any) => message.error({ content, ...config }),
  warning: (content: any) => message.warning({ content, ...config }),
};
